import {
  Component,
  ComponentRef,
  Directive,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  Type,
  ViewContainerRef
} from '@angular/core';
import { DynamicComponentFactoryService } from './dynamic-component-factory.service';
import { DynamicComponentTerminatorService } from './dynamic-component-terminator.service';
import { Subject } from 'rxjs';
import { IDynamicComponent } from './interfaces';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[d-component]',
  template: ``,
  providers: [DynamicComponentFactoryService, DynamicComponentTerminatorService]
})
export class DynamicComponentComponent implements OnInit, OnChanges, OnDestroy {
  @Input() is: string | Type<IDynamicComponent>;

  @Input() data: any;

  ref: ComponentRef<IDynamicComponent>;

  readonly unsubscribe$ = new Subject<void>();

  constructor(
    public viewContainerRef: ViewContainerRef,
    public factory: DynamicComponentFactoryService,
    private terminator: DynamicComponentTerminatorService
  ) {}

  ngOnInit(): void {
    this.terminator.onDestroy.subscribe(() => this.ngOnDestroy());
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.is && changes.is.currentValue) {
      const is = changes.is.currentValue;
      if (this.ref) {
        this.viewContainerRef.remove(0);
      }

      if (typeof is === 'string') {
        this.ref = this.factory.createByName(this.viewContainerRef, is);
      } else {
        this.ref = this.factory.createByType(this.viewContainerRef, is);
      }
    }
    // 输入参数
    if (changes.data && changes.data.currentValue && typeof changes.data.currentValue === 'object') {
      if (this.ref) {
        this.ref.instance.config = changes.data.currentValue;
      }
    }
  }

  ngOnDestroy(): void {
    const { unsubscribe$ } = this;
    unsubscribe$.next();
    unsubscribe$.complete();
    this.ref.destroy();
  }
}
